export default __webpack_public_path__ + "static/media/ProportioTypeScale.697e4df5.png";